<template>
    <b-modal ref="mdlFlussiView" :title="'Dettaglio'" size="xl" hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div class="b-table-sticky-header">
            <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData" :fields="fields" :current-page="1" :per-page="10000000000" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                <template #cell(index)="row">
                    {{ row.index + 1 }}
                </template>
                <template #cell(quotaAsl)="{ item }">
                    {{ formatFloat(item.quotaAsl, 2) }}
                </template>
                <template #cell(quotaComune)="{ item }">
                    {{ formatFloat(item.quotaComune, 2) }}
                </template>
                <template #cell(quotaUtente)="{ item }">
                    {{ formatFloat(item.quotaUtente, 2) }}
                </template>
            </b-table>
        </div>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import axios from "axios";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            pathResource: "/flussidettaglio",
            pathResourceDettaglio: "/flussilogdettagli",
            idRisorsa: null,
            readOnly: false,
            listKey: 0,
            jsonData: [],
            fields: [
                {
                    label: "*",
                    key: "index",
                },
                {
                    label: "Cognome",
                    key: "cognome",
                },
                {
                    label: "Nome",
                    key: "nome",
                },
                {
                    label: "Identificativo",
                    key: "identificativo",
                },
                {
                    label: "Giorni",
                    key: "giorniPresenza",
                },
                {
                    label: "Q. A.S.L.",
                    key: "quotaAsl",
                },
                {
                    label: "Q. Comune",
                    key: "quotaComune",
                },
                {
                    label: "Q. Utente",
                    key: "quotaUtente",
                },
            ],
        };
    },
    methods: {
        loadData() {
            let me = this;
            let filtro = { idFlussiFiles: me.idRisorsa };
            UtilityMixin.methods.loadDataResources(me.pathResource, filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data.list;
            me.$refs.mdlFlussiView.show();
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        init(id) {
            let me = this;
            me.idRisorsa = id;
            me.loadData();
        },
        onDownload(item) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDettaglio + "/download/" + item.id;
            axios({
                url: link, //your url
                method: "GET",
                responseType: "blob", // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                let nomeFile = item.nomeFile;
                link.setAttribute("download", nomeFile + ".txt"); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
    },
};
</script>

<style></style>
